export const countriesWithNoPostalCode = [
  'AO', // Angola
  'AG', // Antigua & Barbuda
  'AW', // Aruba
  'BS', // Bahamas
  'BZ', // Belize
  'BJ', // Benin
  'BW', // Botswana
  'BO', // Bolivia
  'BF', // Burkina Faso
  'BI', // Burundi
  'CM', // Cameroon
  'CF', // Central African Republic
  'KM', // Comoros
  'CG', // Congo - Brazzaville
  'CD', // Congo - Kinshasa (Democratic Republic of the Congo)
  'CK', // Cook Islands
  'CI', // Côte d’Ivoire
  'CW', // Curaçao
  'DJ', // Djibouti
  'DM', // Dominica
  'GQ', // Equatorial Guinea
  'ER', // Eritrea
  'FJ', // Fiji
  'TF', // French Southern Territories
  'GA', // Gabon
  'GM', // Gambia
  'GH', // Ghana
  'GD', // Grenada
  'GY', // Guyana
  'HM', // Heard Island and McDonald Islands
  'HK', // Hong Kong SAR China
  'KI', // Kiribati
  'LY', // Libya
  'MO', // Macau SAR China
  'MW', // Malawi
  'ML', // Mali
  'MR', // Mauritania
  'NR', // Nauru
  'KP', // North Korea
  'QA', // Qatar
  'RW', // Rwanda
  'KN', // St. Kitts & Nevis
  'ST', // São Tomé & Príncipe
  'SC', // Seychelles
  'SL', // Sierra Leone
  'SB', // Solomon Islands
  'SR', // Suriname
  'SY', // Syria
  'TL', // Timor-Leste
  'TG', // Togo
  'TK', // Tokelau
  'TO', // Tonga
  'TV', // Tuvalu
  'UG', // Uganda
  'AE', // United Arab Emirates
  'VU', // Vanuatu
  'YE', // Yemen
  'ZW' // Zimbabwe
]
